/* eslint-disable max-len */

import { AuthContextInterface, withAuthContext } from '@amzn/awscat-react-components';
import { isPartnerUserId } from '@amzn/caracal-infrastructure-common';
import { useEffect, useState } from 'react';

import LandingPage, { LandingProps } from './LandingPage';
import { AppLabels } from '../../common/AppLabels';
import { AppLabelsContextInterface, withAppLabelsContext } from '../../common/AppLabelsContext';
import ExternalLinks from '../../common/ExternalLinks';

const Landing = (props: AppLabelsContextInterface & AuthContextInterface): JSX.Element => {
    const appLabels: AppLabels = props.appLabels;
    const [isPartner, setIsPartner] = useState(false);

    useEffect(() => {
        try {
            setIsPartner(isPartnerUserId(props.auth?.getUserInfo()?.userId));
        } catch {
            // Auth may not be available yet
        }
    }, [props.auth]);

    // Filter out AWS Prescriptive Guidance Library for partner users
    const relatedServicesItems = isPartner
        ? appLabels.landing.relatedServices.items.filter((item) => item.serviceLinkLocation !== ExternalLinks.APG)
        : appLabels.landing.relatedServices.items;

    const data: LandingProps = {
        title: appLabels.landing.title,
        serviceName: appLabels.landing.serviceName,
        majorDescription: appLabels.landing.majorDescription,
        minorDescription: appLabels.landing.minorDescription,
        whatItDoes: {
            title: appLabels.landing.whatItDoes.title,
            description: appLabels.landing.whatItDoes.description,
        },
        gettingStarted: {
            title: appLabels.landing.gettingStarted.title,
            links: [{ linkLocation: '/assessments/create', linkText: appLabels.landing.gettingStarted.links[0].linkText }],
        },
        benefitsAndFeatures: {
            title: appLabels.landing.benefitsAndFeatures.title,
            items: appLabels.landing.benefitsAndFeatures.items,
        },
        // Hide all More Resources links for partner users
        ...(!isPartner && {
            moreResources: {
                title: appLabels.landing.moreResources.title,
                items: appLabels.landing.moreResources.items,
            },
        }),
        relatedServices: {
            title: appLabels.landing.relatedServices.title,
            items: relatedServicesItems,
        },
    };
    return <LandingPage {...data} />;
};

export default withAuthContext(withAppLabelsContext(Landing));
